import ValuePropsModule from './ValuePropsModule';

export * from './ValuePropsModule';
export default ValuePropsModule;
